/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { IdDiamondDown } from "../IdDiamondDown";
import "./style.css";

export const Movements = ({
  movement = "Movement info",
  className,
  override = (
    <IdDiamondDown
      btnIconArrowColor="#0066FF"
      className="id-diamond-down-instance"
      rectangleClassName="design-component-instance-node"
    />
  ),
  divClassName,
  frameClassName,
  dateClassName,
  amountClassName,
  text = "$600,50",
}) => {
  return (
    <div className={`movements ${className}`}>
      <div className="frame-3">
        {override}
        <div className={`movement-info ${divClassName}`}>{movement}</div>
      </div>

      <div className={`frame-4 ${frameClassName}`}>
        <div className={`date ${dateClassName}`}>11/06/22</div>

        <div className={`amount ${amountClassName}`}>{text}</div>
      </div>
    </div>
  );
};

Movements.propTypes = {
  movement: PropTypes.string,
  text: PropTypes.string,
};
